export const EVENT_NAMES = {
  HEALTHIERSG_HEALTHPLAN_TODO: 'hsg_healthplan_todo',
  HEALTHIERSG_HEALTHPLAN_SUMMARY: 'hsg_healthplan_summary',
  HEALTHIERSG_HEALTHPLAN_TOOLS: 'hsg_healthplan_tools',
  HEALTHIERSG_LIFESTYLE_PAGE: 'hsg_lifestyle_page',
  HEALTHIERSG_GENAI_PAGE: 'hsg_hpai_page',
  HEALTHIERSG_GENAI_ACTION: 'hsg_hpai_action',
  HH_NOTIFICATIONS: 'hh_notifications',
  MEMBER_PRN: 'memberPRN',
  USER_PRN: 'userPRN',
  HSG_HP_DASHBOARD_PAGE: 'hsg_hp_page',
  HEALTHIERSG_SCREENING_ACTION: 'hsg_hp_screening_action',
  HEALTHIERSG_HEALTHPLAN_VACCINATION_ACTION: 'hsg_hp_vaccination_action',
  HEALTHIERSG_LIFESTYLE_ACTION: 'hsg_hp_lifestyle_action',
  HEALTHIERSG_AAC_ACTION: 'hsg_hp_aac_action',
  HSG_HP_CONSULT_ACTION: 'hsg_hp_consult_action',
};

export const EVENT_ACTIONS = {
  EXERCISE_PLANNER: 'exercisePlanner',
  VIEW_DETAILS: 'viewDetails',
  CUSTOMIZE: 'customize',
  GENERATE_NEW_PLAN: 'generateNewPlan',
  VIEW_HEALTH_PLAN_SUMMARY: 'viewHealthPlanSummary',
  NOTIFY_HEALTHPLAN_READY: 'notify_healthplan_ready',
  NOTIFY_ELIGIBLE_SCREENING: 'notify_eligible_screening',
  NOTIFY_ELIGIBLE_VACCINATION: 'notify_eligible_vaccination',
  THUMBSUP: 'thumbsUp',
  THUMBSDOWN: 'thumbsDown',
  BOOK_HSG_CONSULT: 'bookHsgConsult',
  GET_SCREENED: 'getScreened',
  GET_VACCINATED: 'getVaccinated',
  FORM_ONBOARDING: 'formOnboarding',
  FORM_FAGERSTROM: 'formFagerstrom',
  GO_HEALTHY365: 'goHealthy365',
  I_QUIT_PROG: 'iQuitProg',
  VIEW_LIFESTYLE_PRESCRIPTION: 'viewLifestylePrescription',
  VIEW_PROGRAMMES: 'viewProgrammes',
  GO_H365: 'goH365',
  QUIT_SMOKING_SUPPORT: 'quitSmokingSupport',
  VIEW_SCREENING_DETAILS: 'view_screening_details',
  VIEW_SCREENING_RECORDS: 'view_screening_records',
  BOOK_SCREENING_APPOINTMENT: 'book_screening_appointment',
  BOOK_NONHAS_SCREENING_APPOINTMENT: 'book_nonHAS_screening_appointment',
  BOOK_EXISTING_SCREENING_APPOINTMENT: 'book_existing_screening_appointment',
  BOOK_VACCINATION_APPOINTMENT: 'book_vaccination_appointment',
  VIEW_VACCINATION_RECORDS: 'view_vaccination_records',
  VIEW_VACCINATION_DETAILS: 'view_vaccination_details',
  EXERCISE_LEARN_HOW: 'exercise_learnHow',
  DIET_LEARN_HOW: 'diet_learnHow',
  SLEEP_LEARN_HOW: 'sleep_learnHow',
  ARTICLE_VIEW_MORE: 'article_viewMore',
  LOCATE_AAC: 'locate_aac',
  BOOK_HP_APPOINTMENT: 'book_hp_appointment',
};

export const PAGE_STATE = {
  EXERCISE_PLAN: 'exercisePlan',
  RENEW_EXERCISE_PLAN: 'renewExercisePlan',
  EXERCISE_DETAILS: 'exerciseDetails',
  ACTIVITY_DETAILS: 'activityDetails',
  FEEDBACK: 'feedback',
  PRE_CONSULT: 'preConsult',
  POST_CONSULT: 'postConsult',
};
